<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <div class="jk-grid-cols-4"> 
    <app-jkdatefield  label="交易日期" #LE001Com  id="LE001"  [(value)]="item.LE001" [required]="true"  placeholder="交易日期"  [readonly]="isBrowse" 
            >
    </app-jkdatefield>
    <app-jktext  label="時間" [value]="item.LE002"     >
    </app-jktext>
    <app-jkedit  label="股票代號" #LE003Com  id="LE003"  [(value)]="item.LE003" placeholder="股票代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="股票名稱" #LE006Com  id="LE006"  [(value)]="item.LE006" placeholder="股票名稱"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkcheckboxYN  label="已讀" #LE008Com  id="LE008"  [(valueYN)]="item.LE008"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jkcheckboxYN  label="已傳" #LE009Com  id="LE009"  [(valueYN)]="item.LE009"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jkedit  label="條件代號" #LE010Com  id="LE010"  [(value)]="item.LE010" placeholder="條件代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="條件名稱" #LE004Com  id="LE004"  [(value)]="item.LE004" placeholder="條件名稱"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jknumberedit  label="已說次數" #LE012Com  id="LE012"  [(value)]="item.LE012" placeholder="已說次數"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="價格" #LE013Com  id="LE013"  [(value)]="item.LE013" placeholder="價格"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkedit  label="流程碼" #LE005Com  id="LE005"  [(value)]="item.LE005" placeholder="流程碼"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="內容" #LE007Com  id="LE007"  [(value)]="item.LE007" placeholder="內容"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktext  label="序號" [value]="item.LE011"     >
    </app-jktext>

    </div>
  </div>
</div>